<template>
  <div>
    <div class="login">
      <div class="user-top">
        <mu-icon @click="goback" value="arrow_back"></mu-icon>
        <a @click="toLogin" style="padding-right:10px;color:#1882d4;">登录</a>
      </div>
      <dl class="user-title">
        <dd>手机注册</dd>
      </dl>

      <div class="user-form">
        <mu-text-field min-length="6" full-width v-model="phone" placeholder="请填写本人实名手机号码"></mu-text-field>

        <br />
        <mu-button color="primary" :disabled="phone.length<6" full-width @click="nextStep()">下一步</mu-button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api"

export default {
  data() {
    return {
      phone: ""
    };
  },
  methods: {
    toLogin() {
      this.$router.push("/login");
    },
    nextStep() {
      this.$store.state.phone=this.phone;
      Api.isReg(this.phone).then((res)=>{
       if(!res.data.hasOwnProperty("error")){
           Api.getVcode(this.phone).then(res=>{
          
           })
                     this.$store.state.vcode="888888"
          this.$router.push("/passwordset")
           //this.$router.push("/vcode");
        }
        else {
          this.$toast(res.data.error);
        }
      })
      
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.user-top {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  align-items: center;
}
.user-title {
  padding: 40px 10px;
  width: 50%;
  text-align: left;
  font-size: 2rem;
}
.user-form {
  display: flex;
  padding: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.myinput {
  height: 50px;
  width: 80%;
  border: gray;
}
</style>>

</style>


// WEBPACK FOOTER //
// src/pages/Register.vue